module.exports = __webpack_public_path__ + "img/nightware-logo.32a345fa.png";